export default class View {
  constructor(model) {
    if (model) {
      for (const prop of Object.keys(model)) {
        this[prop] = model[prop];
      }
    }
  }
}
